import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_POOLS_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_POOLS_WEB_CLIENT_ID,

    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: [
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: process.env.REACT_APP_COGNITO_CALLBACK_DOMAIN,
      redirectSignOut: process.env.REACT_APP_COGNITO_CALLBACK_DOMAIN,
      responseType: "token",
    },

    cookieStorage: {
        domain: process.env.REACT_APP_COGNITO_COOKIE_DOMAIN,
        path: "/",
        expires: 1,
        secure: true,
        sameSite: "lax",
    },
  },
});
